<template>
  <div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row justify-content-between mb-3 mx-0">
          <h3 v-if="userHasControl">Upload Intake Form File</h3>
          <button
            v-if="userHasControl && vendor.intakeFormInfo"
            :disabled="deleting"
            class="btn btn-sm btn-danger"
            @click="deleteFile"
          >
            <i class="fas fa-spin fa-circle-notch mr-2" v-if="deleting"></i>
            Delete File
          </button>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  v-if="userHasControl"
                  @change="onFileSelected"
                  :disabled="uploading"
                  accept="application/pdf"
                />
                <label class="custom-file-label" v-if="userHasControl"
                  >Choose PDF File</label
                >

                <alert v-if="uploading" class="mt-5"
                  ><i class="fas fa-spin fa-circle-notch mr-2"></i
                  >Uploading...</alert
                >
                <iframe
                  v-if="vendor.intakeFormInfo && !uploading"
                  class="vendor-intake-form-frame mt-5"
                  :src="vendor.intakeFormInfo.split('?response-content')[0]"
                ></iframe>
                <alert v-if="!vendor.intakeFormInfo && !uploading" class="mt-5"
                  >No intake form file uploaded yet.</alert
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../auth";

export default {
  name: "VendorPolicy",
  data() {
    return {
      uploading: false,
      deleting: false,
    };
  },
  computed: {
    ...mapState(["vendors", "loading"]),
    vendor: function () {
      return this.vendors.single;
    },
    id: function () {
      return this.$route.params.id;
    },
    loggedInUser: function () {
      return Auth.user.get();
    },
    userHasControl: function () {
      if (!this.vendor) {
        return false;
      }
      if (
        this.loggedInUser.isAdmin ||
        ((this.vendor.admins || []).length &&
          this.vendor.admins.includes(this.loggedInUser.id))
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.vendors.single) {
      this.$store.dispatch("vendors/get", { id: this.id });
    }
  },
  methods: {
    onFileSelected: function (event) {
      var file = event.target.files[0];
      if (file.type == "application/pdf") {
        this.uploading = true;
        this.$store
          .dispatch("vendors/uploadIntakeForm", {
            vendor: this.vendors.single,
            file,
          })
          .then(() => {
            this.uploading = false;
            this.$store.dispatch("vendors/get", { id: this.id });
          });
      } else {
        Swal.fire({
          title: "Validation Error",
          text: "Selected file is not a PDF!",
          type: "error",
        });
      }
    },
    deleteFile: function () {
      this.deleting = true;
      this.$store
        .dispatch("vendors/removeIntakeForm", {
          id: this.id,
        })
        .then((success) => {
          this.deleting = false;
          if (success) {
            Swal.fire({
              title: "File Deleted",
              text: "File deleted successfully",
              type: "success",
            });
            this.$store.dispatch("vendors/get", { id: this.id });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.vendor-intake-form-frame {
  width: 100%;
  height: 100vh;
  border: 0;
}
</style>
